import { trpc } from '@/shared/api/trpc';

const SIXTY_SECONDS = 60 * 1000;

// Opt out of batching: this count joins external messages up through
// item → version → itinerary and would otherwise hold up the
// `operations.list` request sharing the batch. Run it on its own request so
// the item list renders as soon as it's ready (mirrors useFlaggedCountsData).
export const useFailedMessageCountData = () =>
  trpc.operations.failedMessageCount.useQuery(undefined, {
    refetchInterval: SIXTY_SECONDS,
    staleTime: SIXTY_SECONDS,
    trpc: { context: { skipBatch: true } },
  });
